import { j as p } from "../../jsx-runtime-ClSzPYp4.js";
import { s as r } from "../../index.esm-DOxVcNnO.js";
import { styled as t, css as s } from "styled-components";
import { system as a, compose as n, color as c, typography as m, space as i, display as l } from "styled-system";
const d = a({
  whiteSpace: {
    property: "whiteSpace",
    defaultScale: {
      normal: "normal",
      nowrap: "nowrap",
      pre: "pre",
      "pre-wrap": "pre-wrap",
      "pre-line": "pre-line",
      "break-spaces": "break-spaces"
    }
  }
}), f = /* @__PURE__ */ t.span.withConfig({
  shouldForwardProp: (e) => r(e)
}).withConfig({
  componentId: "sc-487ff6ed-0"
})([
  "",
  " ",
  ""
], ({ theme: e, size: o }) => /* @__PURE__ */ s([
  "",
  " ",
  ""
], e.components.text.base, e.components.text[o]), n(c, m, i, l, d)), u = ({ size: e = "medium", ...o }) => /* @__PURE__ */ p.jsx(f, {
  size: e,
  ...o
});
export {
  f as StyledText,
  u as default,
  d as styledWhiteSpace
};
